module.exports = __webpack_public_path__ + "img/en_logo.721492b5.png";